module.exports = __webpack_public_path__ + "static/loto_plus-88e585ff1759df41cb047b4f5ad28e95.svg";